import React, { FC, ReactNode } from 'react';
import classNames from 'classnames';
import styles from './ListLayout.module.scss';

interface ListLayoutProps {
    className?: string;
    children: ReactNode;
}

export const ListLayout: FC<ListLayoutProps> = ({ className, children }) => {
    return <div className={classNames(styles.listLayout, className)}>{children}</div>;
};

export default ListLayout;
